import { polyfillConnectors } from '@ui/lib/wallet';
import { useDisconnect } from 'wagmi';

export const useCurrentConnector = () => {
  const { connectors } = useDisconnect();

  const current = connectors.at(0);
  const polyfill = current
    ? polyfillConnectors.find((c) => c.id === (current as any).id)
    : undefined;

  return {
    connector: current,
    icon: polyfill?.icon ?? current?.icon,
  };
};
